
import { defineComponent } from 'vue';
import PricingCards from './PricingCards.vue';

export default defineComponent({
  components: {
    PricingCards,
  },
});
